import { render, staticRenderFns } from "./note-details.vue?vue&type=template&id=14192a04"
import script from "./note-details.vue?vue&type=script&lang=js"
export * from "./note-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports